// extracted by mini-css-extract-plugin
export default {"link":"Badge_link__aA-j-","badge":"Badge_badge__y1Nfb","wrapper":"Badge_wrapper__Rwqe3","count":"Badge_count__I6wWM","text":"Badge_text__-vDNl"};